import dynamic from 'next/dynamic';
import React from 'react';

// Hydration error, see: https://github.com/cookpete/react-player/issues/1474
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

interface ReactPlayerWrapperProps {
  url: string;
  disabled?: boolean;
}

const ReactPlayerWrapper: React.FC<ReactPlayerWrapperProps> = ({ url, disabled = false }: ReactPlayerWrapperProps) => (
  <div className='relative aspect-video'>
    {disabled && <div className='absolute z-10 h-full w-full' />}
    <ReactPlayer url={url} width='100%' height='100%' className='absolute left-0 top-0' controls />
  </div>
);

export default ReactPlayerWrapper;
